import { createSlatePlugin } from 'platejs';

import { AffiliateLinkElement, PLATE_KEYS } from 'features/Editor';

export const AffiliateLinkPlugin = createSlatePlugin({
	key: PLATE_KEYS.affiliateLink,
	node: { isLeaf: true, component: AffiliateLinkElement },
	parsers: {
		html: {
			deserializer: {
				rules: [{ validNodeName: ['A'] }],
				query: ({ element }) => {
					return element.getAttribute('href') === '{affiliate_link}';
				},
			},
		},
	},
}).extendTransforms(({ editor, type }) => ({
	toggle: () => {
		editor.tf.toggleMark(type);
	},
}));
